import type { FaireProductEntity } from "../../entity_types/product";

export const p_bmm2auffaw: FaireProductEntity = {
  token: "p_bmm2auffaw",
  type: "product",
  name: "Storrow Drive Boston - Greeting Card",
  brandToken: "b_2nlyab4cca",
  brandName: "Sarah Wormann Art",
  imageUrl: "https://cdn.faire.com/fastly/ee61d674b2a65de6bd304a48669e00d211bcb01bf22b0060f91fedec99fcc6d7.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c0b1dada62894796eeb2b1d343e335b0c1eda075265d547345444c1585590b95.png",
    "https://cdn.faire.com/fastly/9a797f5b6bf73cf66330d1f7f091604f0cf430a6f75593ca872969ac9c6036a1.jpeg"
  ],
  priceDollars: 3,
  description: "Greeting card with an illustration of a box truck getting Storrowed, originally painted with gouache, and the words \"I'd drive a moving truck on Storrow for you\" underneath. For anyone who knows not to take a truck down Boston's Storrow Drive!\n\nSmall-batch greeting card created, printed, and packaged by hand in Boston, MA. Perfect for gift shops and boutiques seeking unique, locally-made stationery.\n\n• Standard A2 greeting card size: 4.25\" x 5.5\"\n• Blank inside for personalization\n• Includes coordinating envelope\n• Comes in a protective clear sleeve, ready for display\n\nEach card is created by Sarah in her Boston home studio, offering customers unique designs with a personal, handcrafted touch.",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T08:03:53.487Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
